import { useBooleanFlagValue } from "@openfeature/react-sdk";
import { FeatureFlagVariables } from "../../../constants/featureFlag";

export function useIsRealEstatesAvailable(): boolean {
  const defaultValue = false;

  const isRealEstatesAvailable = useBooleanFlagValue(FeatureFlagVariables.isRealEstatesAvailable, defaultValue);

  return isRealEstatesAvailable;
}
